import robot from './robot.json';

export default { ...robot };
